export default "__VITE_ASSET__DwLvWqNT__"